/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\CreateAccount\Agreement\Agreement.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Wednesday September 4th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday September 4th 2024 10:02:17 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { forwardRef, useImperativeHandle, useState } from "react";
import Styles from "Content/CreateAccount/Agreement/Agreement.module.css";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { muiStyle } from "Theme/Mui";

type AgreementProps = {
    onUpdate: Function;
};

const Agreement = forwardRef((props: AgreementProps, ref) => {
    const [commercialCallTime, setCommercialCallTime] = useState<Date>();
    const [sellAgreementTime, setSellAgreementTime] = useState<Date>();

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            commercialCallTime,
            sellAgreementTime
        };
    }, [commercialCallTime, sellAgreementTime]);

    const handleChange = (e: any, setter: React.Dispatch<React.SetStateAction<Date | undefined>>) => {
        if (e.target.checked)
            setter(new Date());
        else
            setter(undefined);
    };

    return (<div className={`${Styles.formHolder}`}>
            <h3 className="m-0">{translator.decode("agreement.title")}</h3>
            <FormGroup>
                <FormControlLabel required sx={muiStyle} control={<Checkbox onClick={(e) => handleChange(e, setSellAgreementTime)} />} label={<span>{translator.decode("agreement.cgv")} <a href="/cgv" className={`${Styles.cgv}`} target="_blank">{translator.decode("agreement.cgvName")}</a></span>} />
                <FormControlLabel control={<Checkbox onClick={(e) => handleChange(e, setCommercialCallTime)} />} label={translator.decode("agreement.commercial")} />
            </FormGroup>
        </div>
    );
});

export default Agreement;
